export const calcularProgreso = (actividades = []) => {
    if (actividades?.length === 0) return 0;
  
    const total = actividades?.length;
    const vigentes = actividades?.filter((a) => a.Vigencia === "Vigente").length;
  
    return Math.round((vigentes / total) * 100);
  };
  